import React, { useEffect, useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { hooks as commonHooks } from '@sitebuilder/common';
import { ItemsTable, TextInput } from '../BaseComponents';
import { actionCreators } from '../../reducers/media';
import { StateShape as ReduxStateShape } from '../../reducers';
import { folderGreySvg } from '../../assets/images';

const MediaPicker = (props: WidgetProps) => {
    const { schema, value, placeholder, onChange, uiSchema, options } = props;
    const [showModal, setShowModal] = useState<boolean>(false);
    const dispatch = useDispatch();
    const i18n = commonHooks.useLocalization();

    useEffect(() => {
        // set base path for images
        if (!options?.isImagePicker && !options.isFontPicker) {
            dispatch(actionCreators.listMedias(''));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const { medias } = useSelector((state: ReduxStateShape) => state.media);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e?.target?.value);
    };

    return (
        <div className="media-picker" id={props.id}>
            <div className="browse-input">
                <TextInput
                    label={schema.title}
                    placeholder={placeholder}
                    defaultValue={value}
                    value={value}
                    onChange={handleChange}
                    labelId={'custom-input-label'}
                    inputId={'custom-text-input'}
                    disabled={uiSchema?.['ui:disabled']}
                />
                <img
                    className={'browse-img'}
                    src={folderGreySvg}
                    alt={'browse-button'}
                    onClick={() => setShowModal(!showModal)}
                />
            </div>
            <Modal className="media-picker-modal" data-testid="modal" show={showModal} size="xl">
                <div className="modal-custom-header">
                    <button
                        className="close-modal-button"
                        onClick={() => setShowModal(false)}
                        aria-label={i18n.translate('widgets_closeModal') as string}
                    >
                        <i className="fas fa-times" />
                    </button>
                </div>
                <div className="modal-body">
                    <ItemsTable
                        tableType={'media'}
                        items={medias}
                        selectedItems={[]}
                        onClickRow={() => null}
                        isWithinFilePicker={true}
                        closeMediaPicker={() => setShowModal(false)}
                        setPath={(path) => onChange(path)}
                        isImagePicker={options.isImagePicker as boolean}
                        isFontPicker={options.isFontPicker as boolean}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default MediaPicker;
